import { getBackendBaseUrl } from "@entrilia/shared/variables";

// Operations-authenticated APIM API that routes to the BI Engine query-trace hub. The hub lives in the
// BI Engine but is consumed only by the Operations portal, so it is fronted by an ops-realm gateway
// (see Azure/APIM/bi-engine.bicep -> entrilia-operations-reporting-api) rather than the Admin-Portal
// reporting API.
export const smartViewsTraceHubUrl = `${getBackendBaseUrl("operations-reporting")}/biQueryTraceHub`;
